import { style } from 'constant/constants';
import { Grid, InputLabel, MenuItem, Select } from '@mui/material/index';
import PropTypes from 'prop-types';

const FilterDropdown = ({ options, label, setFilterBy, filterBy, gridSx, selectSx }) => {
  const handleChange = (event) => {
    setFilterBy(event.target.value);
  };

  return (
    <Grid
      item
      xs={12}
      sx={{
        width: 400,
        height: 30,
        justifyContent: 'flex-end',
        alignItems: 'center',
        ...gridSx
      }}
      display="flex">
      <InputLabel
        htmlFor="demo-simple-select-label"
        sx={{
          fontFamily: style.fontFamily,
          color: style.LIGHT.primary,
          mt: 0,
          mr: 1,
          height: 20,
          alignItems: 'center'
        }}
        className="text-menu-color-green">
        {label}
      </InputLabel>
      <Select
        value={filterBy}
        size="small"
        sx={{ width: 120, fontFamily: style.fontFamily, mt: 0, mb: 0, height: 30, ...selectSx }}
        name={label}
        onChange={handleChange}>
        {options?.length > 0 &&
          options.map((op) => (
            <MenuItem value={op.value} key={op.value} sx={{ fontFamily: style.fontFamily }}>
              {op.name}
            </MenuItem>
          ))}
      </Select>
      <InputLabel
        htmlFor="demo-simple-select-label"
        sx={{
          fontFamily: style.fontFamily,
          color: style.LIGHT.primary,
          mt: 0,
          ml: 1,
          mr: 1,
          height: 20,
          alignItems: 'center'
        }}
        className="text-menu-color-green"></InputLabel>
    </Grid>
  );
};

export default FilterDropdown;

FilterDropdown.propTypes = {
  setFilterBy: PropTypes.func,
  filterBy: PropTypes.string,
  options: PropTypes.array,
  label: PropTypes.string,
  gridSx: PropTypes.object,
  selectSx: PropTypes.object
};
